import Vue from 'vue'
import VueApollo from 'vue-apollo'
import ApolloClient from 'apollo-boost'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueApollo)

// eslint-disable-next-line no-undef
const site_url = typeof pageInfo !== 'undefined' ? pageInfo.site_url : window.location.origin

const apolloClient = new ApolloClient({
  uri: site_url + '/graphql'
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})

new Vue({
  render: h => h(App),
  apolloProvider //injecting apolloProvider to root vue instance
}).$mount('#gpd-region-app')
